import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  skeletonWrapper: {
    marginTop: "20px"
  },
  firstRow: {
    display: "flex",
    gap: "10px",
  },
  column: {
    display: "flex",
    flexDirection: "column",
  },
  firstPart: {
    display: "flex",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  secondRow: {
    marginLeft: "auto",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginLeft: "0",
    },
  },
  shortSk: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin: "20px 0px",
  },
});

export default styles;
